<template>
  
    <div class="level_warp">
      <div class="index-name">
        <span>{{ data.name }}</span>
        <el-button
          size="mini"
          type="primary"
          plain
          @click="$router.push(data.path)"
          >编辑</el-button
        >
      </div>
      <li class="lower-level-line line" v-if="data.children"></li>
      <div class="level" v-if="data.children">
        <div
          class="level_warp"
          :class="{ mantle: data.children.length > 1 }"
          v-for="item in data.children"
          :key="item.name"
        >
          <li class="higher-level-line line"></li>
          <div class="index-name">
            <span class="name">{{ item.name }}</span>
            <el-button
              size="mini"
              type="primary"
              plain
              @click="$router.push(item.path)"
              >编辑</el-button
            >
          </div>
          <li class="lower-level-line line" v-if="item.children"></li>
          <div
            :class="{ level: item.children.length > 1 }"
            v-if="item.children"
          >
            <div
              class="level_warp"
              :class="{ mantle: item.children.length > 1 }"
              v-for="i in item.children"
              :key="i.name"
            >
              <li
                class="higher-level-line line"
                v-if="item.children.length > 1"
              ></li>
              <div class="index-name">
                <span class="name">{{ i.name }}</span>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  @click="$router.push(i.path)"
                  >编辑</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        name: "个人主页（后台）",
        path: "/operate/pageManage/personalAfter/personal",
        
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.level_warp {
  .mantle {
    &:first-child {
      position: relative;
      &::before {
        top: 0;
        content: "";
        width: 1px;
        height: 50%;
        position: absolute;
        background-color: #ffffff;
      }
    }
    &:last-child {
      position: relative;
      &::after {
        content: "";
        width: 1px;
        bottom: 0;
        position: absolute;
        height: calc(50% - 1px);
        background-color: #ffffff;
      }
    }
  }
}

.level_warp {
  display: flex;
  padding: 12px 0;
  align-items: center;

  .title {
    display: flex;
    padding: 10px;
    align-items: center;
    border: 1px solid $--color-primary;
    border-radius: $--border-radius-base;
    span {
      font-size: 0.75rem;
    }
  }

  .line {
    width: 60px;
    height: 1px;
    min-width: 30px;
    background-color: $--color-primary;
    &[class*="lower-level-line"] {
      max-width: 100px;
    }
  }

  .index-name {
    width: 170px;
    display: flex;
    padding: 4px 15px;
    align-items: center;
    border: 1px solid $--color-primary;
    span {
      font-size: 0.875rem;
    }
    .el-button {
      margin-left: auto;
    }
  }

  .level {
    position: relative;

    &::before {
      top: 0;
      left: 0;
      bottom: 0;
      content: "";
      width: 1px;
      position: absolute;
      background-color: $--color-primary;
    }
  }
  .score {
    height: 40px;
    padding: 0 24px;
    line-height: 40px;
    font-size: 0.875rem;
    border: 1px solid $--color-primary;
    border-radius: $--border-radius-base;
  }
}
</style>